import Image from 'next/image';
import Button from '../../atoms/button/Button';
import classes from './TwoColumnCopyImageAdv.module.scss';

export default function TwoColumnCopyImageAdv({ data }) {
    const { cta } = data;
    let isAnchor = data?.isAnchor;
    return (
        <div
            className={`${classes.oTwoColumnCopyImage} ${classes[`${data.id}`]} ${
                classes[`${data.theme}`]
            } ${classes[`${data.imagePosition}`]}`}
        >
            {isAnchor && <div className={`${classes.isAnchor}`} id={data.id}></div>}
            <div className={classes.oWrapper}>
                <div className={classes.oImage}>
                    <figure className={classes.mImage}>
                        <Image
                            src={data.image?.url}
                            width={data.image?.width}
                            height={data.image?.height}
                            alt={data.image?.title}
                            layout="responsive"
                            id={data.image?.id}
                            className={classes.aImage}
                        />
                    </figure>
                </div>
                <div className={classes.oCopy}>
                    <div className={classes.mWrapper}>
                        <p className={`${classes.aTitle} fnt16f`}>{data.title}</p>
                        {data.heading && (
                            <h2 className={`${classes.aHeading} fnt38f fnt-b`}>{data.heading}</h2>
                        )}
                        <div
                            className={`${classes.aCopy} fnt18f`}
                            dangerouslySetInnerHTML={{ __html: data.copy }}
                        ></div>
                        <Button data={cta} />
                    </div>
                </div>
            </div>
        </div>
    );
}
